import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerCarouselClick = props => {
  const datalayerCarouselClickHandler = event => {
    const validClasses = ["flickity-prev-next-button", "flickity-page-dot"]

    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      let carouselAction,
        carouselName =
          document.querySelector("title").innerText + " Page Carousel",
        carouselSetNumber,
        carouselItemsPerSet,
        totalCarouselSets,
        carouselOuter = event.target.closest(".ter-carousel")

      carouselAction = event.target.classList.contains("next")
        ? "next"
        : event.target.classList.contains("previous")
        ? "prev"
        : event.target.classList.contains("flickity-page-dot")
        ? `slide ${event.target.innerText}`
        : null
      carouselSetNumber = carouselOuter?.querySelector(
        ".flickity-page-dot.is-selected"
      ).innerText
      carouselItemsPerSet =
        carouselOuter?.querySelector(".carousel-cell")?.children.length
      totalCarouselSets =
        carouselOuter?.querySelectorAll(".flickity-page-dot").length

      window.dataLayer.push({
        event: "carousel_click",
        carousel_name: carouselName, //descriptive name for the carousel
        carousel_action: carouselAction, //'next, 'previous','number'
        carousel_set_number: carouselSetNumber,
        carousel_items_per_set: carouselItemsPerSet,
        total_carousel_sets: totalCarouselSets,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".flickity-prev-next-button, .flickity-page-dot"
      ).length > 0
  }
  useClickListener(datalayerCarouselClickHandler, query)
}

export default DatalayerCarouselClick
